import React from 'react';
import { motion } from 'framer-motion';

const TestimonialsSection = () => {
  const videoTestimonials = [
    {
      name: "Ayush",
      role: "Data Analyst",
      video: "https://media-manager-c.questera.ai/greta-media/d1e1f795f547d188310881b3e1dfad84afccd53626664f205958a3becb1b00f4f5d96fb34b3d15472c5f30d572e92287/videos/dmlkZW8vbXA0/53466fcaddc97d9e13215334e1fb8afb.mp4"
    },
    {
      name: "Ashit",
      role: "Business Intelligence",
      video: "https://media-manager-c.questera.ai/greta-media/d1e1f795f547d188310881b3e1dfad84afccd53626664f205958a3becb1b00f4f5d96fb34b3d15472c5f30d572e92287/videos/dmlkZW8vbXA0/3790c2953cc72f635d33711a982a5c55.mp4"
    },
    {
      name: "Ebanian",
      role: "Power BI Developer",
      video: "https://media-manager-c.questera.ai/greta-media/d1e1f795f547d188310881b3e1dfad84afccd53626664f205958a3becb1b00f4f5d96fb34b3d15472c5f30d572e92287/videos/dmlkZW8vbXA0/0434d7b88210a453358a1f17294197d6.mp4"
    },
    {
      name: "Marie",
      role: "Data Specialist",
      video: "https://media-manager-c.questera.ai/greta-media/d1e1f795f547d188310881b3e1dfad84afccd53626664f205958a3becb1b00f4f5d96fb34b3d15472c5f30d572e92287/videos/dmlkZW8vbXA0/9ee04bc657e83ec6befb457ba8595882.mp4"
    }
  ];

  const testimonials = [
    {
      quote: "From survival jobs to a career-defining role. The roadmap was my blueprint to success.",
      image: 'https://media-manager-c.questera.ai/greta-media/d1e1f795f547d188310881b3e1dfad84afccd53626664f205958a3becb1b00f4f5d96fb34b3d15472c5f30d572e92287/images/aW1hZ2UvanBlZw==/666ff5e2178821c63985c24e8ce6a75e.jpeg'
    },
    {
      quote: "The Power BI skills I learned here got me noticed by top recruiters within weeks.",
      image: 'https://media-manager-c.questera.ai/greta-media/d1e1f795f547d188310881b3e1dfad84afccd53626664f205958a3becb1b00f4f5d96fb34b3d15472c5f30d572e92287/images/aW1hZ2UvanBlZw==/b3eb8270a85900d4e591d094c849dadf.jpeg'
    },
    {
      quote: "I finally secured a role that sponsors my H1B. This program is a game changer.",
      image: 'https://media-manager-c.questera.ai/greta-media/d1e1f795f547d188310881b3e1dfad84afccd53626664f205958a3becb1b00f4f5d96fb34b3d15472c5f30d572e92287/images/aW1hZ2UvanBlZw==/d4a31193d3c8a492a9dff0d7f5e69412.jpeg'
    },
    {
      quote: "Truly practical knowledge. I'm now managing dashboards for a major tech firm.",
      image: 'https://media-manager-c.questera.ai/greta-media/d1e1f795f547d188310881b3e1dfad84afccd53626664f205958a3becb1b00f4f5d96fb34b3d15472c5f30d572e92287/images/aW1hZ2UvanBlZw==/642ce89a4a13f5c5c4983e6bf5f5d07d.jpeg'
    },
    {
      quote: "Even with my academic background, I needed this corporate logic to break into tech.",
      image: 'https://media-manager-c.questera.ai/greta-media/d1e1f795f547d188310881b3e1dfad84afccd53626664f205958a3becb1b00f4f5d96fb34b3d15472c5f30d572e92287/images/aW1hZ2UvanBlZw==/11d17d9a37c493c27452e83c875e2c72.jpeg'
    },
    {
      quote: "The 90-day plan works! I received my offer letter exactly 3 months after starting.",
      image: 'https://media-manager-c.questera.ai/greta-media/d1e1f795f547d188310881b3e1dfad84afccd53626664f205958a3becb1b00f4f5d96fb34b3d15472c5f30d572e92287/images/aW1hZ2UvanBlZw==/ded71df40c5f376469ee8f79594b3c67.jpeg'
    },
    {
      quote: "Zero coding background, but I'm now a Data Analyst. Highly recommended!",
      image: 'https://media-manager-c.questera.ai/greta-media/d1e1f795f547d188310881b3e1dfad84afccd53626664f205958a3becb1b00f4f5d96fb34b3d15472c5f30d572e92287/images/aW1hZ2UvanBlZw==/cdaa24ca24083e70277c6850c998c157.jpeg'
    },
    {
      quote: "My salary doubled within a year. Power BI is the ultimate leverage tool.",
      image: 'https://media-manager-c.questera.ai/greta-media/d1e1f795f547d188310881b3e1dfad84afccd53626664f205958a3becb1b00f4f5d96fb34b3d15472c5f30d572e92287/images/aW1hZ2UvanBlZw==/a53c694a9c71cf22f210bde486290f8b.jpeg'
    },
    {
      quote: "The resume checklist alone got me 5 interviews in the first week.",
      image: 'https://media-manager-c.questera.ai/greta-media/d1e1f795f547d188310881b3e1dfad84afccd53626664f205958a3becb1b00f4f5d96fb34b3d15472c5f30d572e92287/images/aW1hZ2UvanBlZw==/89639ead5385c64a275e71bcac2f8e8f.jpeg'
    },
    {
      quote: "Finally, a roadmap that understands the unique challenges of international students.",
      image: 'https://media-manager-c.questera.ai/greta-media/d1e1f795f547d188310881b3e1dfad84afccd53626664f205958a3becb1b00f4f5d96fb34b3d15472c5f30d572e92287/images/aW1hZ2UvanBlZw==/41770e32460fceda948529af4c01e07b.jpeg'
    },
    {
      quote: "The portfolio projects were the highlight of my interview discussion.",
      image: 'https://media-manager-c.questera.ai/greta-media/d1e1f795f547d188310881b3e1dfad84afccd53626664f205958a3becb1b00f4f5d96fb34b3d15472c5f30d572e92287/images/aW1hZ2UvanBlZw==/bcf5df6beb8f486baed1639dd2b0c53a.jpeg'
    }
  ];

  return (
    <section className="py-24 bg-black relative">
      <div className="container mx-auto px-6">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="text-pbi-yellow font-bold uppercase tracking-widest text-sm mb-3 block">
            The Results Speak For Themselves
          </span>
          <h2 className="text-4xl md:text-5xl font-black text-white mb-6">
            Real Success <span className="text-pbi-yellow">Stories</span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-lg">
            Join thousands of international students who transformed their careers using our Power BI Blueprint.
          </p>
        </motion.div>

        {/* Video Testimonials Section */}
        <div className="mb-20">
          <div className="flex items-center gap-4 mb-8 justify-center lg:justify-start">
            <div className="h-1 w-12 bg-pbi-yellow rounded-full"></div>
            <h3 className="text-2xl font-bold text-white">Watch Student Experiences</h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {videoTestimonials.map((video, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: idx * 0.1, duration: 0.6 }}
                viewport={{ once: true }}
                className="bg-gray-900 rounded-xl overflow-hidden border border-gray-800 shadow-2xl group"
              >
                <div className="relative aspect-[9/16] bg-black">
                  <video 
                    controls 
                    className="w-full h-full object-cover"
                    preload="metadata"
                  >
                    <source src={video.video} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
                <div className="p-4 border-t border-gray-800 bg-gray-900/90">
                  <h4 className="text-pbi-yellow font-bold text-lg">{video.name}</h4>
                  <p className="text-gray-400 text-xs uppercase tracking-wider">{video.role}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Image Testimonials Grid */}
        <div>
          <div className="flex items-center gap-4 mb-8 justify-center lg:justify-start">
            <div className="h-1 w-12 bg-gray-700 rounded-full"></div>
            <h3 className="text-2xl font-bold text-gray-300">More Success Stories</h3>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {testimonials.map((item, idx) => (
              <motion.div 
                key={idx}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: idx * 0.1, duration: 0.6 }}
                viewport={{ once: true }}
                className="flex flex-col h-full"
              >
                {/* Testimonial Text Above Image */}
                <div className="bg-gray-900/40 p-6 rounded-t-2xl border-t border-x border-gray-800 relative mb-0 flex-grow min-h-[140px] flex flex-col justify-center">
                  <i className="fa-solid fa-quote-left text-pbi-yellow/20 text-xl absolute top-4 left-4"></i>
                  <p className="text-gray-300 text-sm leading-relaxed italic relative z-10">
                    "{item.quote}"
                  </p>
                </div>

                {/* Proof Image Below Text */}
                <div className="relative group rounded-b-2xl overflow-hidden border border-gray-800 shadow-xl bg-gray-900">
                  <img 
                    src={item.image} 
                    alt="Student Success Proof" 
                    className="w-full h-auto object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;